<template>
  <div class="quest-activity w-100">
    <div class="sandbox">
      <Blockly :test-case="item.testCase" :toolbox="item.toolbox" :max-blocks="item.maxBlocks" @on-finish-testing="testHandler"/>
    </div>
    <transition name="slide-top">
      <div class="info-bar-wrapper"
           :class="{'highlight-element': isMinibarReady && !isInfoOpen && !userDataStore.isTutorialShown}"
           v-if="!isInfoOpen && isMinibarReady && !isEndShown"
           @click="openInfo"
      >
        <div class="info-bar-content">
          <span>{{item.description}}</span>
          <i class="fas fa-angle-down text-hint-icon"/>
        </div>
      </div>
    </transition>
    <div class="info-wrapper" ref="info" :class="{'closed': !isInfoOpen}" @click="close">
      <div class="grid-container text-content" @click="isClickingModal = true">
        <div class="info-metadata">
          <b>Task No. {{paddingZero(item.taskId)}}</b>
          <p>{{item.name}}<br><strong>{{structure.xp}}</strong><small>XP</small></p>
        </div>
        <hr>
        <div v-html="item.content"/>
        <hr>
        <div class="flex flex-spaced mt-1">
          <router-link :to="{ name: 'listings' }" class="btn btn--tab btn--red"><i class="fas fa-arrow-left mr-1"></i>Kembali ke menu utama</router-link>
          <button class="btn btn--tab" @click="openWindow"><i class="far fa-window-restore mr-1"></i>Buka teks di jendela lain</button>
          <button class="btn btn--tab" @click="close"><i class="fas fa-times mr-1"></i>Tutup teks</button>
        </div>
      </div>
    </div>
    <transition name="scale-out">
      <div class="start-screen" v-if="isStartShown" @click="hideStart">
        <div class="start-screen-content">
          <div class="anim-1">Task No. {{paddingZero(item.taskId)}}</div>
          <div class="anim-2">~ {{item.name}} ~</div>
          <div class="anim-3 mt-1">{{structure.description}}<br><b>Reward:</b> {{structure.xp}}<small>XP</small></div>
        </div>
      </div>
    </transition>
    <transition name="slide-fade-left">
      <div class="end-screen" v-if="isEndShown">
        <div class="end-screen-content">
          <div class="end-header" :style="{'animation': isFinishedCountingScore && score > 49.99 ? 'flash 1s' : 'none'}">
            Task No. {{paddingZero(item.taskId)}}
            <span v-if="isFinishedCountingScore">{{endText}}</span>
          </div>
          <p>{{item.name}}</p>
          <h1
            class="end-score"
            :class="{
              'gold': isFinishedCountingScore && score > 99.99,
              'silver': isFinishedCountingScore && score > 49.99 && score < 99.99,
            }"
          >
            {{shownScore.toFixed(2)}}%
          </h1>
          <div class="prev-high-score" v-if="!hasNotLogin" :class="{'appear': isFinishedCountingScore}">
            Rekor Sebelumnya <b>{{prevHighScore.toFixed(2)}}%</b>
            <small v-if="score > prevHighScore" class="new-record">REKOR BARU!!</small>
          </div>
          <div v-if="!hasNotLogin" class="end-stats" :class="{'appear': isFinishedCountingScore}">
            <user-bar v-if="isFinishedCountingScore" class="w-100"/>
            <div class="end-statistics">
              <b>Statistik</b>
              <hr>
              <div class="flex space-between">
                <p>Blok digunakan</p>
                <b>{{blockCount}}</b>
              </div>
              <div class="flex space-between" :class="{'text-gray': correctItem === 0}">
                <p>Kasus uji</p>
                <b>{{correctItem}}/{{item.testCase.length}}</b>
              </div>
              <div class="flex space-between" :class="{'text-gray': expGained === 0}">
                <p>XP diperoleh</p>
                <b>{{expGained}}<small>XP</small></b>
              </div>
              <div class="flex space-between" :class="{'text-gray': performanceGained === 0}">
                <p>Performance</p>
                <b>+{{performanceGained}}</b>
              </div>
              <hr>
            </div>
          </div>
          <div v-else class="p-1" :class="{'appear': isFinishedCountingScore}">
            Masuk untuk menyimpan kemajuanmu di Blocode!
          </div>
          <div class="end-button">
            <router-link :to="{ name: 'listings' }" class="btn m-0 mr-1">
              <i class="fas fa-arrow-left m-icon-r"></i>
              Kembali ke menu utama
            </router-link>
            <button class="btn m-0 mr-1" @click="isEndShown = false">
              <i class="fas fa-arrow-up m-icon-r"></i>
              Ulangi soal ini
            </button>
          </div>
        </div>
      </div>
    </transition>
    <transition name="scale-out-ease">
      <div class="hint-section"
           v-if="isMinibarReady && !isInfoOpen && !userDataStore.isTutorialShown"
           @click="userDataStore.isTutorialShown = true"
      >
        <div class="hint-text">
          <div>
            <i class="fas fa-arrow-up"/>
          </div>
          Klik di sini untuk menampilkan ulang teks dan<br>
          mengakses menu-menu lainnya!<br><br><br>
          <b>Klik di mana saja untuk melanjutkan</b>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import Blockly from '@/components/Blockly'
  import anime from 'animejs'
  import TaskStructure from './TasklistPayload/TaskStructure'
  import TaskContent from './TasklistPayload/TaskContent'
  import UserBar from '@/components/UserBar'
  import {paddingZero} from '@/utilities/number'

  export default {
    name: 'lessonsActivity',
    components: {
      Blockly,
      UserBar
    },
    data() {
      return {
        item: null,
        structure: null,
        isInfoOpen: false,
        infoWindow: null,
        isClickingModal: false,
        isStartShown: true,
        startTimeout: null,
        isMinibarReady: false,
        isEndShown: false,
        score: 0.0,
        prevHighScore: 0.00,
        blockCount: 0,
        correctItem: 0,
        shownScore: 0.0,
        performanceGained: 0,
        expGained: 0,
        expGainedRemaining: 0,
        isFinishedCountingScore: false,
      }
    },
    computed: {
      endText() {
        if (this.score > 99.99) return 'complete!'
        else if (this.score > 49.99) return 'passed!'
        else return ''
      },
      userDataStore() {
        return this.$store.state.userStore
      },
      hasNotLogin() {
        return this.$store.getters['userStore/hasNotLogin']
      }
    },
    watch: {
      isFinishedCountingScore(val) {
        if (!val) return
        this.updateStats()
      }
    },
    beforeRouteLeave (to, from, next) {
      let res = true
      if (!this.isEndShown) {
        res = confirm("Kamu belum menyelesaikan task ini.\nKonfirmasikan keluar dari halaman ini?")
      }

      next(res);
    },
    created() {
      const id = parseInt(this.$route.params.id)
      this.item = TaskContent[id-1]
      this.structure = TaskStructure[id-1]

      window.addEventListener('beforeunload', this.beforeUnloadHandler);
    },
    mounted() {
      const textWrapper = document.querySelector('.anim-2');
      textWrapper.innerHTML = textWrapper.textContent.replace(/\S/g, "<span class='letter' style='display: inline-block;'>$&</span>");

      anime.timeline()
        .add({
          targets: '.anim-1',
          translateX: [40,0],
          translateZ: 0,
          opacity: [0,1],
          easing: "easeOutExpo",
          duration: 1200,
          delay: (el, i) => 300 + 30 * i
      })
      anime.timeline()
        .add({
          targets: '.anim-2 .letter',
          translateX: [40,0],
          translateZ: 0,
          opacity: [0,1],
          easing: "easeOutExpo",
          duration: 1200,
          delay: (el, i) => 500 + 30 * i
        })
      anime.timeline()
        .add({
          targets: '.anim-3',
          opacity: [0,1],
          easing: "easeOutExpo",
          duration: 1200,
          delay: 1000
        })
      this.startTimeout = setTimeout(() => {
        this.hideStart()
      }, 5000)
    },
    destroyed() {
      window.removeEventListener('beforeunload', this.beforeUnloadHandler)

      if (this.isEndShown && !this.isFinishedCountingScore) {
        this.updateStats()
      }
      if (document.querySelector(".blocklyHtmlInput")) {
        document.querySelector(".blocklyHtmlInput").style.display = 'none'
      }
      if (this.infoWindow && !this.infoWindow.closed) {
        this.infoWindow.close()
      }
    },
    methods: {
      paddingZero,
      beforeUnloadHandler(e) {
        if (!this.isEndShown) {
          e.preventDefault();
          e.returnValue = '';
        }
      },
      testHandler(result, blockCount) {
        let points = 0
        let isEqual = require('lodash/isEqual')

        for (let i in this.item.testCase) {
          if (isEqual(result[i], this.item.testCase[i].output)) points++
        }

        this.isEndShown = true
        this.isFinishedCountingScore = false
        this.blockCount = blockCount
        this.correctItem = points
        this.shownScore = 0.0
        this.score = Math.round(points*1.0/this.item.testCase.length * 10000)/100.00
        this.expGainedRemaining = 25

        const animatingScore = setInterval(() => {
          if (this.score - this.shownScore < 0.5) {
            this.shownScore = this.score
            this.isFinishedCountingScore = true
            clearInterval(animatingScore)
          } else {
            this.shownScore += (this.score - this.shownScore) / 10.0
          }
        }, 20)
      },
      openInfo() {
        this.isInfoOpen = true
        this.$refs.info.scrollTop = 0
      },
      close() {
        if (this.isClickingModal)
          this.isClickingModal = false
        else
          this.isInfoOpen = false
      },
      openWindow() {
        const id = this.$route.params.id
        if (!this.infoWindow || this.infoWindow.closed) {
          this.infoWindow = window.open(`${document.URL.split("/")[1]}/tasklist/task/text/${id}`, 'title', 'location=no,height=570,width=520,scrollbars=yes,status=yes,toolbar=no')
        } else {
          this.infoWindow.focus()
        }
        this.close()
      },
      hideStart() {
        this.isStartShown = false
        setTimeout(() => {
          this.isInfoOpen = true
          this.isMinibarReady = true
        }, 200)
        clearTimeout(this.startTimeout)
      },
      updateStats() {
        if (this.hasNotLogin) {
          return
        }

        this.expGained = 0
        let currentPerformance = 0
        const taskId = this.item.taskId
        const index = this.userDataStore.finishedTask.findIndex(
          (item) => item.taskId === taskId
        )

        if (index !== -1) this.prevHighScore = this.userDataStore.finishedTask[index].score

        if (index === -1) {
          this.expGained = Math.floor(this.score * this.structure.xp / 100.0)
          this.userDataStore.finishedTask.push({
            taskId,
            score: this.score,
            expGained: this.expGained,
            name: this.item.name,
            type: 'single'
          })
        }
        else if (this.score > this.userDataStore.finishedTask[index].score) {
          this.expGained =
            Math.floor(this.score * this.structure.xp / 100.0) - this.userDataStore.finishedTask[index].expGained

          this.userDataStore.finishedTask[index].score = this.score
          this.userDataStore.finishedTask[index].expGained = Math.floor(this.score * this.structure.xp / 100.0)
        }

        this.expGainedRemaining = this.expGained
        currentPerformance = this.$store.getters['userStore/getPerformance']
        this.performanceGained = currentPerformance - this.userDataStore.performancePoint

        setTimeout(() => {
          this.$store.commit('userStore/setPerformancePoint', {value: currentPerformance})
          const animatingXP = setInterval(() => {
            if (this.expGainedRemaining === 0) {
              clearInterval(animatingXP)
            } else {
              this.$store.dispatch('userStore/incrementExp')
              this.expGainedRemaining--;
            }
          }, 100)
        }, 300)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "src/styles/colors";

  .quest-activity {
    overflow: hidden;
    position: relative;
  }

  .sandbox {
    height: 100vh;
  }

  .info-bar-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1;
    display: flex;
    pointer-events: none;
  }

  .info-bar-content {
    margin: auto;
    background-color: white;
    box-shadow: 0 5px 10px 0 rgba(black, 0.1);
    padding: 0.25rem 1rem;
    border-radius: 0 0 10px 10px;
    pointer-events: auto;
    cursor: pointer;
    font-weight: 500;
  }

  .text-hint-icon {
    margin: 0 0.25rem;
  }

  .info-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    background-color: rgba(black, 0.3);
    z-index: 100;
    display: flex;
    padding: 0 1rem 2rem 1rem;
    overflow-y: auto;
    box-sizing: border-box;
    transition: background-color 0.8s 0.1s;
  }

  .text-content {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: auto;
    padding: 1rem;
    background-color: white;
    border-radius: 0 0 10px 10px;
    max-width: 800px;
    box-shadow: 0 10px 10px 0 rgba(black, 0.2);
    transition: all 0.2s ease-out;
  }

  .info-metadata {
    display: flex;
    justify-content: space-between;
    align-items: center;

    b {
      font-weight: 900;
      font-size: 1.5rem;
      background: linear-gradient(to bottom right, #296f99, #314380);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    p {
      background: linear-gradient(to bottom right, #296f99, #314380);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      text-align: end;
    }
  }

  .info-wrapper.closed {
    background-color: rgba(black, 0);
    overflow-y: hidden;
    pointer-events: none;
    transition: background-color 0.3s;

    .text-content {
      transform: translateY(calc(-50px));
      opacity: 0;

      transition: all 0.2s ease-in;
    }
  }

  .start-screen, .end-screen {
    position: absolute;
    z-index: 101;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    padding: 1rem;
    box-sizing: border-box;

    &::before {
      content: "";
      height: 100%;
      width: 100%;
      position: absolute;
      z-index: -1;
      left: 0;
      top: 0;
      background-color: rgba(white, 0.85);
      transform: scale(1.5);
    }

    .start-screen-content, .end-screen-content {
      margin: auto;
      text-align: center;
      width: 100%;
    }

    .end-button {
      display: flex;
      padding: 1rem;
      box-sizing: border-box;
      width: 100%;
      justify-content: center;
      margin: auto;
    }

    .end-score {
      font-variant-numeric: tabular-nums;
      font-size: 4rem;
      font-weight: 900;
      letter-spacing: -4px;
    }

    .end-score.gold {
      color: goldenrod;
      text-rendering: geometricPrecision;
      background: linear-gradient(to bottom, rgba(213,173,109,1) 0%, rgba(213,173,109,1) 26%, rgba(226,186,120,1) 35%, rgba(163,126,67,1) 45%, rgba(145,112,59,1) 61%, rgba(213,173,109,1) 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      text-shadow: 0 0 10px rgba(goldenrod, 0.5);
      animation: glow-grow 0.5s, glowing 3s 0.5s linear infinite;
    }
    .end-score.silver {
      background: linear-gradient(to bottom, rgba(195,214,223,1) 0%, rgba(176,194,207,1) 36%, rgba(146,171,185,1) 50%, rgba(165,209,238,1) 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      text-shadow: 0 0 10px rgba(gray, 0.25);
      animation: glow-grow 0.5s, glowing 3s 0.5s linear infinite;
    }

    .new-record {
      display: inline-block;
      background-color: darkgoldenrod;
      animation: glowing 3s 1.5s linear infinite;
      padding: 0.1rem 0.3rem;
      color: white;
      font-weight: bold;
      border-radius: 5px;
      margin-left: 0.5rem;
    }

    .end-header {
      font-weight: bold;
      font-size: 1.5rem;
      background: linear-gradient(to bottom right, #296f99, #314380);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .prev-high-score {
      opacity: 0;
      transition: opacity 0.5s;
      margin-bottom: 1rem;

      &.appear {
        opacity: 1;
      }
    }

    .end-stats {
      display: flex;
      justify-content: space-between;
      background-color: white;
      border-radius: 10px;
      box-shadow: 0 5px 10px rgba(black, 0.25);
      text-align: start;
      transition: transform 1s 0.2s, opacity 0.7s 0.2s;
      transform: rotate(5deg) translateY(40px);
      opacity: 0;
      max-width: 600px;
      margin: auto;

      &.appear {
        transform: rotate(0) translateY(0);
        opacity: 1;
      }
    }

    .end-statistics {
      width: 100%;
      padding: 1rem;
    }

    .anim-1 {
      font-weight: 900;
      font-size: 2rem;
      background: linear-gradient(to bottom right, #296f99, #314380);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .anim-2 {
      font-weight: bold;
      font-size: 1.25rem;
    }
  }

  .dark-mode {
    .start-screen::before, .end-screen::before {
      background-color: rgba($dark-mode-back-primary, 0.85);
    }

    .info-bar-content, .text-content, .end-stats {
      background-color: $dark-mode-back-secondary;
    }

    .info-metadata > b, .info-metadata > p, .end-header, .anim-1 {
      filter: brightness(2) contrast(0.75);
    }
  }
</style>
